export const heroContent = {
  tag: '每日更新 · 极速播放',
  h1: '青柠影院 — 最新高清电影在线观看平台',
  slogan: '海量大片免费看，精彩不等待',
  intro: '青柠影院汇聚全网最新电影在线资源，为您提供海量高清电影全集免费在线观看服务。无论是刚下线的热门大片还是经典老片，在这里都能找到。wifi环境下流畅观看不卡顿，每日片库持续更新，追新片永远快人一步。当前热播季我们精选了动作巨制、悬疑烧脑与温情喜剧三大主题，满足不同观影口味。',
  stats: [
    { label: '每日更新', value: '50+部' },
    { label: '高清片库', value: '30000+' },
    { label: '流畅播放', value: '不缓冲' },
  ],
  ctas: [
    { label: '立即观影', href: '#media' },
    { label: '热门榜单', href: '#ranking' },
  ],
};

export const mediaItems = [
  {
    id: 1,
    title: '《暗影追踪》终极预告',
    category: '动作 · 悬疑',
    duration: '02:35',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20movie%20poster%20with%20shadowy%20figure%20in%20trench%20coat%20walking%20through%20rainy%20neon-lit%20alley%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20warm%20amber%20and%20teal%20color%20grade%2C%20professional%20movie%20poster%20quality&width=800&height=450&seq=media-01&orientation=landscape',
    tag: '热映中',
  },
  {
    id: 2,
    title: '《星际迷航：新纪元》片段',
    category: '科幻 · 冒险',
    duration: '03:18',
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20battle%20scene%20with%20massive%20starships%20and%20colorful%20nebula%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20professional%20movie%20scene%20quality%20with%20warm%20orange%20and%20deep%20blue%20tones&width=800&height=450&seq=media-02&orientation=landscape',
    tag: '新片速递',
  },
  {
    id: 3,
    title: '《团圆饭》温情花絮',
    category: '剧情 · 家庭',
    duration: '04:02',
    image: 'https://readdy.ai/api/search-image?query=Warm%20family%20gathering%20scene%20around%20dinner%20table%20with%20soft%20golden%20evening%20light%2C%20Chinese%20family%20drama%20film%20aesthetic%2C%20cozy%20interior%2C%20emotional%20atmosphere%2C%20professional%20movie%20scene%20quality&width=800&height=450&seq=media-03&orientation=landscape',
    tag: '口碑推荐',
  },
];

export const cardItems = [
  {
    id: 1,
    title: '《暗夜猎手》',
    desc: '硬汉特工孤身潜入敌后，绝地反击上演惊天逆转，全程高能无尿点。',
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20scene%20with%20intense%20hand-to-hand%20combat%20in%20dimly%20lit%20warehouse%2C%20dramatic%20shadows%20and%20dust%20motes%20in%20light%20beams%2C%20cinematic%20photography%2C%20warm%20contrast%20lighting&width=600&height=400&seq=card-01&orientation=landscape',
    tags: ['动作', '惊悚', '2026'],
    rating: '9.2',
  },
  {
    id: 2,
    title: '《深海秘境》',
    desc: '深海探险队发现未知文明遗迹，水下奇观与惊险逃生交织的视觉盛宴。',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20exploration%20scene%20with%20ancient%20ruins%20and%20bioluminescent%20creatures%2C%20deep%20ocean%20blue%20tones%20with%20rays%20of%20sunlight%20penetrating%20water%2C%20cinematic%20adventure%20movie%20aesthetic&width=600&height=400&seq=card-02&orientation=landscape',
    tags: ['科幻', '冒险', '4K'],
    rating: '8.9',
  },
  {
    id: 3,
    title: '《城市之光》',
    desc: '一位盲人钢琴师与流浪歌手在城市角落相遇，用音乐治愈彼此的温暖故事。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20city%20street%20scene%20at%20dusk%20with%20piano%20and%20street%20musician%2C%20golden%20hour%20lighting%2C%20romantic%20drama%20film%20aesthetic%2C%20soft%20focus%20background%20with%20city%20lights&width=600&height=400&seq=card-03&orientation=landscape',
    tags: ['剧情', '治愈', '2026'],
    rating: '9.5',
  },
  {
    id: 4,
    title: '《极限72小时》',
    desc: '三组人马在地下迷宫中争夺神秘宝藏，72小时倒计时的生死竞速。',
    image: 'https://readdy.ai/api/search-image?query=Thriller%20movie%20scene%20in%20underground%20maze%20with%20torch%20lights%20and%20ancient%20stone%20walls%2C%20tense%20atmosphere%2C%20dramatic%20shadows%2C%20cinematic%20suspense%20quality&width=600&height=400&seq=card-04&orientation=landscape',
    tags: ['悬疑', '冒险', '高能'],
    rating: '8.7',
  },
  {
    id: 5,
    title: '《花开时节》',
    desc: '江南小镇的春天，三代女性的命运在花开花落间缓缓展开，细腻动人。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20garden%20in%20spring%20with%20blooming%20flowers%20and%20traditional%20architecture%2C%20soft%20pastel%20colors%2C%20film%20drama%20aesthetic%2C%20gentle%20natural%20light&width=600&height=400&seq=card-05&orientation=landscape',
    tags: ['文艺', '家庭', '豆瓣8.8'],
    rating: '8.8',
  },
  {
    id: 6,
    title: '《机甲风暴》',
    desc: '未来世界中人类驾驶巨型机甲对抗外星入侵者，视觉特效震撼全场。',
    image: 'https://readdy.ai/api/search-image?query=Giant%20robot%20mecha%20battle%20in%20futuristic%20cityscape%2C%20explosions%20and%20dramatic%20lighting%2C%20cinematic%20sci-fi%20action%20scene%2C%20epic%20scale%20with%20warm%20orange%20and%20cool%20steel%20tones&width=600&height=400&seq=card-06&orientation=landscape',
    tags: ['科幻', '动作', 'IMAX'],
    rating: '9.0',
  },
  {
    id: 7,
    title: '《午夜书店》',
    desc: '一家只在午夜营业的旧书店，每本书都藏着一个不为人知的秘密故事。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20old%20bookstore%20at%20night%20with%20warm%20amber%20lighting%2C%20towering%20bookshelves%2C%20mysterious%20atmosphere%2C%20a%20single%20reading%20lamp%20on%20a%20wooden%20desk%2C%20cinematic%20quality&width=600&height=400&seq=card-07&orientation=landscape',
    tags: ['奇幻', '治愈', '高分'],
    rating: '9.1',
  },
];

export const updateItems = [
  { id: 1, date: '07-31', title: '《暗影追踪》票房突破15亿，续集已确认启动', type: 'hot' },
  { id: 2, date: '07-30', title: '暑期档最强片单发布：12部新片陆续上线', type: 'new' },
  { id: 3, date: '07-29', title: '《城市之光》获金像奖最佳影片提名', type: 'hot' },
  { id: 4, date: '07-28', title: '《深海秘境》幕后特辑独家上线青柠影院', type: 'new' },
  { id: 5, date: '07-27', title: '本周新增4K修复经典老片专区，重温光影岁月', type: 'normal' },
  { id: 6, date: '07-26', title: '《机甲风暴》导演确认中国行宣传行程', type: 'hot' },
  { id: 7, date: '07-25', title: '平台观影体验升级：智能推荐算法全新上线', type: 'normal' },
  { id: 8, date: '07-24', title: '《花开时节》豆瓣开分8.8，口碑持续走高', type: 'new' },
  { id: 9, date: '07-23', title: '周末观影指南：三部冷门佳片不容错过', type: 'normal' },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档·动作狂欢',
    subtitle: '肾上腺素飙升的视觉盛宴',
    desc: '从街头追逐到天际对决，从拳拳到肉到枪林弹雨——这个夏天，青柠影院为你精选今年最炸裂的动作大片合集，全程高能不停歇。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20collage%20with%20explosive%20scenes%2C%20car%20chases%20through%20city%20streets%20at%20night%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20cinematic%20quality%2C%20intense%20atmosphere&width=900&height=500&seq=carousel-01&orientation=landscape',
    count: '32部精选',
  },
  {
    id: 2,
    title: '悬疑烧脑·推理之夜',
    subtitle: '每一帧都是线索，每一秒都是反转',
    desc: '高智商犯罪的背后藏着怎样的人性谜题？青柠影院悬疑推理专题，带你走进层层迷雾，体验智商被碾压的快感。反转再反转，不到最后一秒永远猜不到结局。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20atmosphere%20with%20detective%20board%20full%20of%20clues%20and%20red%20strings%2C%20dim%20lighting%2C%20film%20noir%20style%2C%20moody%20shadows%2C%20cinematic%20quality&width=900&height=500&seq=carousel-02&orientation=landscape',
    count: '28部精选',
  },
  {
    id: 3,
    title: '温情喜剧·笑对人生',
    subtitle: '用笑声治愈生活的疲惫',
    desc: '生活不易，更需要开怀大笑。青柠影院温情喜剧专题，汇集国内外高分喜剧佳作，从爆笑段子到温情治愈，总有一部能让你放下烦恼，笑出声来。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20and%20funny%20comedy%20movie%20scene%20with%20group%20of%20friends%20laughing%20in%20sunny%20park%2C%20bright%20cheerful%20colors%2C%20golden%20afternoon%20light%2C%20feel-good%20cinematic%20aesthetic&width=900&height=500&seq=carousel-03&orientation=landscape',
    count: '45部精选',
  },
  {
    id: 4,
    title: '纪实力量·真实故事',
    subtitle: '比电影更震撼的现实',
    desc: '真实胜过虚构，感动源于生活。青柠影院纪录片专题，从自然奇观到人文纪实，从历史揭秘到社会观察，用镜头记录世界最真实的模样，每一部都值得静心品味。',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20film%20aesthetic%20with%20nature%20landscape%20and%20human%20portraits%2C%20earthy%20warm%20tones%2C%20realistic%20cinematography%2C%20wide%20open%20spaces%2C%20thoughtful%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
    count: '56部精选',
  },
];

export const contactContent = {
  title: '影视合作与投稿',
  desc: '欢迎片方、导演、创作者与我们联系。青柠影院开放内容合作通道，为您提供优质曝光资源与专业服务支持。',
  email: 'contact@qingningcinema.com',
  features: ['片源合作', '原创投稿', '广告投放', '版权咨询'],
};

export const featureItems = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量高清片库',
    desc: '超过三万部高清电影全集持续更新，覆盖动作、喜剧、悬疑、科幻等全类型，wifi下流畅在线观看，不缓冲不卡顿。',
  },
  {
    id: 2,
    icon: 'ri-flashlight-line',
    title: '极速加载体验',
    desc: '自研播放引擎搭配全球CDN加速，点击即播无需等待。智能码率自适应技术，根据网络状况自动调整画质。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '纯净观影环境',
    desc: '无弹窗广告打扰，无恶意跳转链接，为您打造沉浸式观影空间。全站内容经过严格审核，观影安全有保障。',
  },
];

export const commentItems = [
  {
    id: 1,
    name: '光影行者',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20middle-aged%20Chinese%20man%20with%20warm%20smile%2C%20professional%20headshot%20style%2C%20soft%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '用了青柠影院快两年了，片库更新速度真的快，基本院线下线一周内就能看到高清版。播放流畅度也没得说，在咖啡厅用wifi看从来没卡过。',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '电影老炮儿',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20an%20older%20Chinese%20man%20with%20glasses%2C%20thoughtful%20expression%2C%20professional%20headshot%20style%2C%20warm%20studio%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '作为一个看了三十年电影的人，青柠影院的片源质量和分类做得非常专业。老片的修复版本很良心，新片的更新速度也让人满意。推荐给所有喜欢看电影的朋友。',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '喵星人爱看电影',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20woman%20with%20bright%20smile%2C%20casual%20style%2C%20professional%20headshot%2C%20soft%20natural%20lighting%2C%20clean%20warm%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '最喜欢周末窝在沙发里刷青柠影院，没有广告这点真的太加分了！画质清晰，加载也快，而且分类做得很细致，随便翻翻就能找到想看的片子。',
    date: '2026-07-22',
  },
  {
    id: 4,
    name: '深夜放映室',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20young%20Chinese%20man%20with%20creative%20style%2C%20professional%20headshot%2C%20soft%20studio%20lighting%2C%20warm%20dark%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '做电影自媒体三年了，青柠影院是我找素材和参考片的重要来源。片库全面、检索方便，尤其是专题策划做得越来越有意思，每次都有新发现。',
    date: '2026-07-20',
  },
  {
    id: 5,
    name: '旅行中的观众',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20woman%20in%2030s%20with%20gentle%20smile%2C%20professional%20headshot%20style%2C%20soft%20warm%20lighting%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '经常出差的人表示这个平台太方便了，酒店wifi下看高清电影从来不缓冲。出差路上的最佳伴侣，已经推荐给了全公司的同事。',
    date: '2026-07-18',
  },
];

export const indexItems = [
  { id: 1, title: '动作大片', count: '1,200+', icon: 'ri-sword-line', desc: '拳拳到肉的硬核动作片合集' },
  { id: 2, title: '悬疑推理', count: '860+', icon: 'ri-search-eye-line', desc: '烧脑反转的高智商悬疑片' },
  { id: 3, title: '科幻世界', count: '740+', icon: 'ri-rocket-line', desc: '未来想象与星际冒险之旅' },
  { id: 4, title: '喜剧天地', count: '1,500+', icon: 'ri-emotion-laugh-line', desc: '爆笑不停的中外喜剧精选' },
  { id: 5, title: '文艺人生', count: '520+', icon: 'ri-quill-pen-line', desc: '细腻动人的独立电影佳作' },
  { id: 6, title: '经典老片', count: '980+', icon: 'ri-film-line', desc: '时光沉淀的影史经典回顾' },
  { id: 7, title: '纪录力量', count: '640+', icon: 'ri-camera-lens-line', desc: '真实故事与社会观察纪实' },
];

export const appContent = {
  title: '随时随地 · 掌上观影',
  desc: '青柠影院移动端适配已完成，手机平板均可获得最佳观影体验。支持投屏到电视，大屏看大片更过瘾。',
  features: ['自适应画质', '投屏到大屏', '离线缓存', '夜间模式'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%20with%20film%20posters%2C%20dark%20theme%20with%20warm%20amber%20accents%2C%20clean%20modern%20UI%20design%2C%20product%20photography%20style%20on%20clean%20background&width=500&height=700&seq=app-mockup&orientation=portrait',
};

export const rankingItems = [
  { id: 1, rank: 1, title: '暗影追踪', hot: '本周播放 286万', change: 'up', desc: '动作悬疑巨制，全程高能反转' },
  { id: 2, rank: 2, title: '城市之光', hot: '本周播放 241万', change: 'up', desc: '治愈系音乐剧情，口碑爆棚' },
  { id: 3, rank: 3, title: '机甲风暴', hot: '本周播放 198万', change: 'down', desc: '视觉特效震撼的科幻动作片' },
  { id: 4, rank: 4, title: '深海秘境', hot: '本周播放 165万', change: 'up', desc: '水下探险的视觉盛宴' },
  { id: 5, rank: 5, title: '午夜书店', hot: '本周播放 132万', change: 'new', desc: '奇幻治愈的深夜故事' },
];

export const aboutContent = {
  title: '关于青柠影院',
  intro: '青柠影院创立于2023年，致力于为广大影迷提供最新电影在线观看服务。我们相信，好的电影应该被更多人看到——无论你在哪里，只要有wifi，就能在青柠影院找到你想看的高清电影全集，流畅在线观看不缓冲。',
  desc: '平台以"让每一部好电影都被看见"为使命，持续引进全球热门大片与优质独立影片。我们建立了严格的片源筛选机制和内容审核流程，确保每一部上线的电影都符合高品质标准。',
  stats: [
    { label: '成立时间', value: '2023年' },
    { label: '累计用户', value: '800万+' },
    { label: '合作片方', value: '200+' },
    { label: '日均更新', value: '50+部' },
  ],
};

export const faqItems = [
  {
    id: 1,
    q: '青柠影院的电影需要付费吗？',
    a: '青柠影院目前所有电影均为免费在线观看，无需付费或会员订阅。只需连接wifi即可流畅观看海量高清电影全集，最新大片同步更新。',
  },
  {
    id: 2,
    q: '观看电影需要下载播放器吗？',
    a: '不需要。青柠影院采用纯网页播放技术，打开浏览器即可直接在线观看，无需安装任何播放器或插件，方便快捷。',
  },
  {
    id: 3,
    q: '为什么有时候播放会卡顿？',
    a: '播放卡顿通常与当前网络环境有关。建议切换至wifi网络以获得最佳观影体验。青柠影院采用智能码率自适应技术，在wifi下可自动调整为高清画质，确保流畅不缓冲。',
  },
  {
    id: 4,
    q: '电影更新频率是怎样的？',
    a: '青柠影院电影频道每日更新，平均每天新增50部以上电影资源。热门大片在院线下线后一周内即可上线，追新片快人一步。',
  },
  {
    id: 5,
    q: '支持哪些设备观看？',
    a: '青柠影院全面适配桌面电脑、笔记本、平板和手机端，所有设备均可流畅在线观看。同时支持投屏到智能电视，大屏观影体验更佳。',
  },
];

export const topicItems = [
  { id: 1, name: '暑期档', hot: true },
  { id: 2, name: '科幻巨制', hot: true },
  { id: 3, name: '豆瓣高分', hot: true },
  { id: 4, name: '悬疑烧脑', hot: false },
  { id: 5, name: '温情治愈', hot: true },
  { id: 6, name: '经典港片', hot: false },
  { id: 7, name: '动作大片', hot: true },
  { id: 8, name: '独立电影', hot: false },
  { id: 9, name: '4K修复', hot: false },
  { id: 10, name: '周末观影', hot: true },
  { id: 11, name: '最新大片', hot: true },
];

export const footerContent = {
  intro: '青柠影院 — 最新电影在线观看平台。海量高清电影全集、热门大片免费看，wifi下流畅不缓冲。每日更新，追新片快人一步。',
  links: [
    { label: '精彩预告', href: '#media' },
    { label: '专题聚焦', href: '#carousel' },
    { label: '热播榜单', href: '#ranking' },
    { label: '热门话题', href: '#topics' },
    { label: '常见问题', href: '#faq' },
    { label: '关于我们', href: '#about' },
  ],
};